import React__default, { useMemo } from 'react';
import styled from 'styled-components';
import { useStepsContext } from './StepsContext.js';
import Box from '../Box/Box.js';

/** */
const Connector = ({
  index,
  isCompletedStep,
  children,
  isLastStep,
  hasLabel,
  isKeepError,
  size = 'md'
}) => {
  const {
    isVertical,
    isLabelVertical,
    widths,
    stepSizes
  } = useStepsContext();
  const stepIconContainerSizes = {
    sm: {
      width: '32px',
      height: '32px',
      borderWidth: '2px'
    },
    md: {
      width: '40px',
      height: '40px',
      borderWidth: '2px'
    },
    lg: {
      width: '48px',
      height: '48px',
      borderWidth: '2px'
    }
  };
  const getMargin = () => {
    if (isVertical) {
      return `calc(${stepIconContainerSizes[size].width} / 2)`;
    }
    if (!hasLabel) return 2;
  };
  const styles = useMemo(() => {
    const base = {
      marginBottom: getMargin(),
      marginTop: isVertical ? 2 : isLabelVertical ? `16px` : 0,
      paddingBottom: isVertical ? 4 : 0,
      marginRight: isVertical || isLabelVertical ? 0 : 2,
      height: isVertical ? 'auto' : '2px',
      alignSelf: isVertical ? 'stretch' : 'auto',
      borderTopWidth: isLastStep || isVertical ? 0 : '2px',
      borderInlineStartWidth: isLastStep || !isVertical ? 0 : '2px',
      minHeight: isLastStep || !isVertical ? 'auto' : '1.5rem',
      borderLeftWidth: isLastStep || !isVertical ? 0 : '2px',
      borderLeftStyle: isVertical ? 'solid' : 'revert',
      marginLeft: isVertical ? '18px' : 'revert'
      // @TODO: TS has gotten the better of me yet again, sx doesn't like this logic 👆
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    };

    if (!isVertical) {
      return {
        ...base,
        borderTopStyle: 'solid'
      };
    }
    if (isLabelVertical) {
      return {
        ...base,
        position: 'absolute',
        top: `calc(${stepIconContainerSizes[size].height} / 2  - ${base.height} / 2)`,
        left: `calc(((${widths === null || widths === void 0 ? void 0 : widths[index]}px + ${stepIconContainerSizes[size].width}) / 2) + 8px)`,
        // use index of next step to determine spacing
        right: `calc((${widths === null || widths === void 0 ? void 0 : widths[index + 1]}px - ${stepIconContainerSizes[size].width}) / -2 + 8px)`
      };
    }
    return base;
  }, [widths, isLabelVertical, isVertical, stepIconContainerSizes[size].height, stepIconContainerSizes[size].width]);
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    sx: {
      borderColor: isCompletedStep && !isKeepError ? 'border.success' : isCompletedStep && isKeepError ? 'border.danger' : 'border.default',
      ...styles
    },
    "data-highlighted": Boolean(isCompletedStep)
  }, isVertical && children);
};
Connector.displayName = "Connector";
const Wrapper = styled(Box).withConfig({
  displayName: "Connector__Wrapper",
  componentId: "sc-hvldx2-0"
})(["display:flex;flex:1;transition-property:border-color;transition-duration:normal;"]);
Connector.displayName = 'Connector';

export { Connector };
